export default {
  mainPageFunerals: [],
  funerals: [],
  funeralCount: 0,
  funeral: {},
  campaign: {},
  invitation: {
    funeralInvitation: {
      deathbedDate: '',
      funeralDate: '',
      deathbedTime: '',
      funeralTime: '',
      deceasedName: '',
      age: '',
      mourners: '',
      mainMournerId: '',
      mainMournerName: '',
      mainMournerPhone: '',
      funeralLocationName: '',
      funeralLocationDtl: '',
      partnerSeq: null,
      partnerDetailSeq: null,
      funeralLatitude: 37.5665,
      funeralLongitude: 126.9780,
      mapAddress: '',
    }
  },
}